<template>
  <div class="m-10">
    <button v-if="!externalNavigation"
        @click="showHowTo = true"
        class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-6 py-3 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-150 border border-indigo-500 hover:border-indigo-400"
      >
        How-To Agent Group
      </button>

    <HowToGuide
      v-if="isGuideVisible"
      :pages="agentGroupGuidePages"
      :initial-page="0"
      @close="handleClose"
      @complete="handleGuideComplete"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import HowToGuide from "@/components/HowToGuide.vue";

import accountImage from "@/assets/howto/account/account.png";
import accountInformationImage from "@/assets/howto/account/account-information.png";
import accountStatusImage from "@/assets/howto/account/account-status.png";
import accountPermissions from "@/assets/howto/account/account-permissions.png";
import accountActions from "@/assets/howto/account/account-actions.png";
import accountPassword from "@/assets/howto/account/account-change-password.png";
import accountDelete from "@/assets/howto/account/account-delete.png";

import agentGroupImage from "@/assets/howto/agentgroup/agentgroup.png";
import agentGroupAddImage from "@/assets/howto/agentgroup/agentgroup-add.png";
import agentGroupCompleteImage from "@/assets/howto/agentgroup/agentgroup-complete.png";
import agentGroupConfigGlobalImage from "@/assets/howto/agentgroup/agentgroup-config-global.png";
import agentGroupHardwareMonitoringImage from "@/assets/howto/agentgroup/agentgroup-hardware-monitoring.png";
import agentGroupInterfaceMonitoringImage from "@/assets/howto/agentgroup/agentgroup-interface-monitoring.png";
import agentGroupOverviewImage from "@/assets/howto/agentgroup/agentgroup-overview.png";
import agentGroupSyntheticTransactionImage from "@/assets/howto/agentgroup/agentgroup-synthetic-transaction.png";
import agentGroupSynthTransactionImage from "@/assets/howto/agentgroup/agentgroup-synth-transaction.png";


export default {
  name: "ParentComponent",
  components: {
    HowToGuide,
  },
  
  props: {
    showHowToPage: {
      type: Boolean,
    },
    externalNavigation: {
      type: Boolean,
    }
  },

  emits: ["showHowToClose"],
  setup(props, { emit }) {
    const showHowTo = ref(false);

    const isGuideVisible = computed(() => {
      return props.externalNavigation ? props.showHowToPage : showHowTo.value;
    }); 

    const agentGroupGuidePages = ref([
    {
        heading: "Navigate to Agent Group",
        upperText: [
            "From the main navigation menu, click on \"Workspace\".",
            "Select \"Agent Groups\" from the submenu.",
            "You'll see the Agent Group Overview page showing all existing Agent Groups."
        ],
        image: agentGroupImage,
        imageAlt: "Agent Group navigation screenshot",
        lowerText: []
    },
    {
        heading: "Initiate Agent Group Creation",
        upperText: [
            "Click the \"Add Agent Group\" button (button on the top-right corner).",
            "This will open the Agent Group configuration form."
        ],
        image: agentGroupAddImage,
        imageAlt: "Add Agent Group button screenshot",
        lowerText: []
    },
    {
        heading: "Add Agent Group",
        upperText: [
            "In the \"name\" field, input a name that will be used to specify the Agent Group eg., \"HR-1\".",
            "Click the \"Select an organisation\" dropdown.",
            "Select the relevant organisation"
        ],
        image: agentGroupOverviewImage,
        imageAlt: "Agent Group creation form",
        lowerText: [
            "This determines which organisation the agent group will be applied to.",
            "Click the \"Create Agent Group\" button (blue button on the bottom right corner).",
            "This will open the Collector Config form."
        ]
    },
    {
        heading: "Global Collector Config",
        upperText: [
            "This form is the global collector config form which specifies the config type, organisation, group and agent. The fields in this form are all disabled and require no user input."
        ],
        image: agentGroupConfigGlobalImage,
        imageAlt: "Agent Group creation form",
        lowerText: [

        ]
    },
    {
        heading: "Interface Monitoring",
        upperText: [
            "Gateway ping - Checks if the network's gateway is reachable.",
            "Wi-Fi - Monitors the Wi-Fi connection status"
        ],
        image: agentGroupInterfaceMonitoringImage,
        imageAlt: "Interface monitoring configuration",
        lowerText: []
    },
    {
        heading: "Hardware Monitoring",
        upperText: [],
        image: agentGroupHardwareMonitoringImage,
        imageAlt: "Hardware monitoring options",
        lowerText: []
    },
    {
        heading: "Hardware Monitoring",
        upperText: [],
        image: null,
        imageAlt: "Hardware monitoring options",
        lowerText: [
            "Process - Tracks CPU, memory, and process usage.",
            "Logical Disk - Monitors disk space, usage, and performance.",
            "Network Interface - Measures network traffic and errors on adapters.",
            "Memory - Reports on memory usage and faults.",
            "Processor - Tracks CPU performance across all cores.",
            "Physical Disk - Monitors read/write activity and disk performance.",
            "System - Provides overall system statistics such as uptime and queue length.",
            "Paging File - Monitors swap (paging file) usage."
        ]
    },
    {
        heading: "Synthetic Transactions",
        upperText: [
            "Click the \"Add New Synthetic Transaction\" button."
        ],
        image: agentGroupSyntheticTransactionImage,
        imageAlt: "Synthetic transactions configuration",
        lowerText: []
    },
    {
        heading: "Synthetic Transactions",
        upperText: [
            "Synthetic Transactions Overview Form"
        ],
        image: agentGroupSynthTransactionImage,
        imageAlt: "Synthetic transactions configuration",
        lowerText: []
    },
    {
        heading: "Synthetic Transactions",
        upperText: [],
        image: null,
        imageAlt: "Synthetic transactions configuration",
        lowerText: [
          "Input the “Name” of the synthetic transaction.",
          "Click on the “Protocol” drop-down and select the protocol eg. “tcp”",
          "Input the “Address” that the synthetic transaction will be using. eg. “8.8.8.8“.",
          "Input the tags for better understanding/specification.",
          "Click the “Save” button (blue button, bottom left).",
          "Click the “Create Config” button.",
          "This will complete the creation of the Agent Group.",

        ]
    },
    {
        heading: "Complete",
        upperText: [
          "On successful completion, this view will be presented"
        ],
        image: agentGroupCompleteImage,
        imageAlt: "Synthetic transactions configuration",
        lowerText: []
    },

]);

    const handleGuideComplete = () => {
      showHowTo.value = false;
      emit("showHowToClose", false);
    };

    const handlePageChange = (pageIndex) => {
      console.log(`User navigated to page ${pageIndex + 1}`);
    };

    const handleClose = () => {
      if (props.externalNavigation){
        emit("showHowToClose", false);
      } else {
        showHowTo.value = false;
      }
    }

    return {
      showHowTo,
      agentGroupGuidePages,
      handleGuideComplete,
      handlePageChange,
      handleClose,
      isGuideVisible
    };
  }
};
</script>